import { graphql } from '__generated__';

import type { AuthUser } from 'common/auth/types';
import { CIError } from 'common/error/error_util';
import gqlClient from 'common/graphql/client';
import { CILogger } from 'common/log/log.provider';
import Sentry from 'common/sentry/sentry';

const SIGN_OUT_MUTATION = graphql(`
    mutation SignOut {
        signOut
    }
`);

export async function revokeBackendSession(authUser: AuthUser | null): Promise<void> {
    try {
        await gqlClient.mutate({ mutation: SIGN_OUT_MUTATION });
    } catch (err) {
        const error = CIError.fromGraphQLError(err);
        CILogger.getInstance().error('signOut mutation failed', error, { subjectId: authUser?.pk });
        Sentry?.captureException(error);
    }
}
